import React, { FunctionComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { decode } from 'utils/crypto/crypto';
import { Balance, Total } from 'utils/api/models/numbers/usage';
import CurrentUsage from './subcomponents/CurrentUsage';
import BalanceCard from './subcomponents/Balance';
import CallDetails from './subcomponents/CallDetails';
import CanPerform from 'components/CanPerform/CanPerform';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { AccountType } from 'utils/api/models/accounts/accountType';

interface IUsageSubpageProps {
	match: {
		url: string;
		params: {
			phoneNumberEncoded: string;
			accountNumber: string;
			accountType: string;
			billingType: string;
		};
	};
	totals: Total[];
	balance: Balance;
}

const UsageDetails: FunctionComponent<any> = ({ match, totals, balance }: IUsageSubpageProps) => {
	const { phoneNumberEncoded, accountNumber, accountType, billingType } = match.params;
	const phoneNumber = decode(phoneNumberEncoded);

	return (
		<div>
			<BalanceCard
				phoneNumberEncoded={phoneNumberEncoded}
				billingType={billingType}
				accountType={accountType}
				balance={balance}
			/>
			<CurrentUsage accountType={accountType} billingType={billingType} totals={totals} url={match.url} />
			<ConditionalRender
				show={accountType !== AccountType.MOBILE}
				onTrue={() => (
					<CanPerform
						action="number-usage:see-call-details"
						yes={
							<CallDetails
								accountType={accountType}
								billingType={billingType}
								phoneNumber={phoneNumber}
								accountNumber={accountNumber}
							/>
						}
					/>
				)}
			/>
		</div>
	);
};

export default withRouter(UsageDetails);
